import { createTileLayerComponent } from "@react-leaflet/core";
import L from "leaflet";

// @ts-ignore
import "leaflet-wms-header";

const createWmsLayer = (props: any, context: any) => {
  const { url, apiKey, ...options } = props;

  // @ts-ignore
  const layer = L.TileLayer.wmsHeader(url, { layers: "Shiveh:Shiveh", format: "image/png", transparent: true, ...options }, [
    { header: "x-api-key", value: apiKey },
  ]);

  return { instance: layer, context };
};

const updateWmsLayer = (instance: any, props: any, prevProps: any) => {
  if (props.url !== prevProps.url) {
    instance.setUrl(props.url);
  }
};

export const MapirLayer = createTileLayerComponent(createWmsLayer, updateWmsLayer);
